export default __webpack_public_path__ + "locales/fr/InviteDialog.json?hash=67e787d9f17285dcc717c2df97d580e3";